import React, { Fragment } from "react";
import IntlMessages from "Util/IntlMessages";
import { Row, Card, CardBody, CardTitle } from "reactstrap";
import ClassicText from "Components/RichEditor/classicEditor";
import { Colxx, Separator } from "Components/CustomBootstrap";
import { BreadcrumbItems } from "Components/BreadcrumbContainer";

function RichEditor() {
  return (
    <Fragment>
      <Row>
        <Colxx xxs="12">
          <div className="mb-2">
            <h1>
              <IntlMessages id="menu.richeditor" />
            </h1>

            <BreadcrumbItems />
          </div>

          <Separator className="mb-5" />

          <Row>
            <Colxx lg="12">
              <div>
                <Card>
                  <CardBody>
                    <CardTitle>Classic Editor</CardTitle>
                    <ClassicText />
                  </CardBody>
                </Card>
              </div>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    </Fragment>
  );
}

export default RichEditor;
